// extracted by mini-css-extract-plugin
module.exports = {"content":"LimitedProfileEntry--content--Y-hnH","description":"LimitedProfileEntry--description--1NdjM"};